import {
  ANALYTICS_PRODUCT_NOT_APPLICABLE,
  AnalyticsData,
  AnalyticsService,
  NotAvailable,
  sendCustomDataEventToAnalytics,
  sendCustomEventToAnalytics,
  sendPageViewEventToAnalytics,
} from '@ui-common/analytics'

import { WizardStep } from '../wizard/wizardMachine'
import { LoanOfferAnalyticsModalName, LoanOfferCustomEventName, LoanOfferPageViewEventName } from './types'

export const wizardStepToPageViewEventNameMap = {
  [WizardStep.InitialLoanOfferStep]: 'InitialLoanOfferStep',
  [WizardStep.GetLoanOfferStep]: 'GetLoanOfferStep',
  [WizardStep.StatusStep]: 'StatusStep',
  [WizardStep.OfferStep]: 'OfferStep',
  [WizardStep.InstallmentStep]: 'InstallmentStep',
  [WizardStep.TermsInfoStep]: 'TermsInfoStep',
  [WizardStep.RecommendationStep]: 'RecommendationStep',
  [WizardStep.BookingStep]: 'BookingStep',
  [WizardStep.TheEndStep]: 'TheEndStep',
} satisfies Record<WizardStep, LoanOfferPageViewEventName>

type WizardStepToPageViewEventNameMap = typeof wizardStepToPageViewEventNameMap

export class LoanOfferAnalyticsService extends AnalyticsService<
  LoanOfferPageViewEventName,
  LoanOfferCustomEventName,
  LoanOfferAnalyticsModalName
> {
  constructor(private readonly data?: AnalyticsData) {
    super()
  }

  getCommonData = (): AnalyticsData => {
    return (
      this.data ?? {
        src: NotAvailable,
        flow: NotAvailable,
        product: ANALYTICS_PRODUCT_NOT_APPLICABLE,
        version: NotAvailable,
        ui_lang: NotAvailable,
      }
    )
  }

  sendPageViewEvent = (view: LoanOfferPageViewEventName): void => {
    sendPageViewEventToAnalytics(view, this.getCommonData())
  }

  sendCustomDataEvent = (data: { [p: string]: string }): void => {
    sendCustomDataEventToAnalytics(data)
  }

  sendCustomEvent = (view: LoanOfferPageViewEventName, name: LoanOfferCustomEventName): void => {
    sendCustomEventToAnalytics(view, name, this.getCommonData())
  }

  sendModalViewEvent = (modal: LoanOfferAnalyticsModalName): void => {
    sendPageViewEventToAnalytics(modal, this.getCommonData())
  }

  sendWizardStepCustomEvent = (step: WizardStep, name: LoanOfferCustomEventName): void => {
    this.sendCustomEvent(getAnalyticsNameForPage(step), name)
  }
}

export const getAnalyticsNameForPage = <T extends WizardStep>(name: T): WizardStepToPageViewEventNameMap[T] => {
  return wizardStepToPageViewEventNameMap[name]
}
